import React from 'react';
import styled from 'styled-components';
import { palette } from 'styles/colors';
import { BaseConfetti } from 'elements/confetti/confetti.styles';
import { layout } from 'styles/layout';

// max-width: 100vw !important is needed to override the layout's 1440px
export const CallToActionContainer = styled.div`
  position: relative;
  overflow: hidden;
  max-width: 100vw !important;
  padding: 5em 17px 5em;
  background: ${palette.snowFlower};

  @media all and (max-width: ${layout.subLg}){
    padding: 2.5em 17px 2.5em;
  }
`

export const CallToActionTextContainer = styled.div`
  max-width: 960px;
  margin: 0 auto 3em;
  padding: 0 3.5rem;
  box-sizing: border-box;
  z-index: 2;
  color: ${palette.white};
`

export const CallToActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  button, a {
    font-size: 1rem;
    width: 256px;
  }
`

export const ConfettiElement = styled(BaseConfetti)`
  position: absolute;
  z-index: 0;
  width: 30%;

  @media screen and (min-width: ${layout.subLg}) {
    width: auto;
  }
`

export const ConfettiElement1 = styled(ConfettiElement).attrs({
  children: <>
    <path d="M235.102 -22.2613L75.7231 -9.18153L96.8555 171.915L235.102 -22.2613Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M219.688 -14.28L85.9269 -1.86234L102.199 150.741L219.688 -14.28Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M205.21 -6.4798L95.6438 4.99512L107.648 130.552L205.21 -6.4798Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M189.489 3.07277L105.393 12.9541L113.516 109.782L189.489 3.07277Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M173.871 13.6078L115.056 22.1592L119.07 90.5786L173.871 13.6078Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M159.088 22.9813L123.462 28.5868L125.461 70.2134L159.088 22.9813Z" stroke="#F1B6B0" strokeWidth="2"/>
    <path d="M144.72 31.7694L130.147 34.0082L131.02 51.0121L144.72 31.7694Z" stroke="#F1B6B0" strokeWidth="2"/>
  </>
})`
  top: 0;
  right: -3.5rem;
`

export const ConfettiElement2 = styled(ConfettiElement).attrs({
  children: <>
    <path d="M150 19.6775L16.0236 106.987L120.746 256.238L150 19.6775Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M140.237 34.0295L28.4797 108.572L115.375 235.07L140.237 34.0295Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M131.211 47.7772L40.2892 109.983L110.566 214.719L131.211 47.7772Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M121.924 63.6577L52.6487 112.348L105.848 193.659L121.924 63.6577Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M113.198 80.3528L65.529 115.848L101.602 174.124L113.198 80.3528Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M104.655 95.6283L75.9821 117.504L97.5391 153.17L104.655 95.6283Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
    <path d="M96.1959 110.193L84.4419 119.093L93.2969 133.636L96.1959 110.193Z" fill="#CD395C" stroke="#FF7062" strokeWidth="2"/>
  </>
})`
  left: 0;
  bottom: 0;
  overflow: hidden;
`
